export default __webpack_public_path__ + "static/HowToSucceed-1c0e08b784bd569d7087472803d0978a.png";